




































































import Vue from 'vue'
import { UserViewModel } from "@/models/UserViewModel.ts";

export default Vue.extend( {
  name: "ToolbarMetroVan",
  computed: {
    loggedInUser(): UserViewModel{
      return this.$store.state.loggedInUser;
    }
  },
  data: function () {
    return {
      // connectionMenuItems: [
      //   {title: 'List Connections', to: {name: 'connections-list'}, router: true},
      // ],
      amendmentMenuItems: [
        { title: 'List Amendments ', to: { name: 'amendments-list' }, router: true},
      ],
      extensionMenuItems: [
        { title: 'List Extensions', to: { name: 'extensions-list' }, router: true},
      ],
      userMenuItems: [
        { title: 'Users' , to: { name: 'users-list' }, router: true } ,
        { title: 'MetroVan Groups' , to: { name: 'metrovan-list' } , router: true } ,
        { title: 'Municipalities' , to: { name: 'municipality-list' } , router: true }
      ]
    }
  }
} )

